import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SportService, UserService } from '@app/core';
import { CommonService } from '@app/core/services/common.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  subscribed: any;
  selectedSport = '';
  showPopup: boolean = false;  // New property to control popup visibility

  constructor(
    private _activated: ActivatedRoute,
    public _user: UserService,
    public _sport: SportService,
    public _common: CommonService,
  ) {}

  ngOnInit(): void {
    // Show the popup after a 3-second delay
    setTimeout(() => {
      this.showPopup = true;  // Trigger the popup to show
    }, 3000);

    // Fetch user profile and other details if needed
  }

  ngOnDestroy(): void {
    // Add cleanup logic if needed
  }

  async followUnfollow(user: any, type = 'follow') {
    let userdetail = this._user.userstate.getValue();
    userdetail.user.is_followed = type == 'follow';
    this._user.userstate.next(userdetail);
    let obj = {
      user_id: user.id,
      kingpin_id: userdetail.id,
    };
    type == 'follow'
      ? await this._user.follow(obj)
      : await this._user.unfollow(obj);
  }
}
